export default "__VITE_ASSET__D9cwsp4m__"